export default "static/dist/img/outline-info-24px.svg?8bfd8780a4d01ba6b676cec3f8761a7c";